


































import Component, { mixins } from "vue-class-component";
import BasePageOneColumn from "@/components/BasePageOneColumn.vue";
import PageTitle from "@/components/PageTitle.vue";
import GoBack from "@/components/GoBack.vue";
import PaymentPackagesContainer from "./components/PaymentPackagesContainer.vue";
import WithPaymentPackages from "@/mixins/WithPaymentPackages";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import { Dictionary } from "@/types";
import { packageTypes, PaymentPackageGroup } from "./config";
import WithCurrency from "@/mixins/WithCurrency";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import {
  InputPaymentPackageCreate,
  InputPaymentPackageUpdate,
  PaymentPackage,
} from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";

@Component({
  name: "PagePricing",
  components: {
    PaymentPackagesContainer,
    WrapperCheckAuthorities,
    GoBack,
    PageTitle,
    BasePageOneColumn,
  },
})
export default class PagePricing extends mixins(WithPaymentPackages, WithCurrency, WithLoadingStatus) {
  public isLoading: boolean = true;

  public showCreate: boolean = false;

  public paymentPackages: Dictionary<PaymentPackage[]> = {};

  public currencyList: Currency[] = [];

  get packageTypes() {
    return packageTypes.reduce((out, packageTypeData) => {
      out.push({
        type: packageTypeData.type,
        name: packageTypeData.name,
        description: packageTypeData.description,
        paymentPackages: this.paymentPackages[packageTypeData.type] || [],
        addButtonText: packageTypeData.addButtonText,
        editDescriptionType: packageTypeData.editDescriptionType,
        editDescription: packageTypeData.editDescription,
        hideCosts: packageTypeData.hideCosts,
      });
      return out;
    }, [] as Array<PaymentPackageGroup & { paymentPackages: PaymentPackage[] }>);
  }

  public packageUpdate({ data, type }: { data: InputPaymentPackageUpdate; type: string }) {
    this.paymentPackagesUpdate({ data }).then(() => {
      this.getData(type);
    });
  }

  public packageAdd({ data, vm }: { data: InputPaymentPackageCreate; vm: any }) {
    this.paymentPackagesCreate({ data }).then(() => {
      this.getData(data.type).then(() => {
        this.showCreate = false;
        vm.values = {};
      });
    });
  }

  public packageDelete({ packageId }: { packageId: string }) {
    this.paymentPackagesDelete({ packageId }).then(() => {
      this.getData();
    });
  }

  public getData(type?: string) {
    return this.paymentPackagesFindAll({ type: type ? [type] : undefined }).then(response => {
      let data: Dictionary<PaymentPackage[]> = {};
      if (type) {
        data = {
          ...this.paymentPackages,
          [type]: [],
        };
      }
      this.paymentPackages = response.reduce((out, item) => {
        if (!Array.isArray(out[item.type])) out[item.type] = [];
        if (type && item.type === type) {
          out[item.type].push(item);
        } else if (!type) {
          out[item.type].push(item);
        }
        return out;
      }, data);
      return response;
    });
  }

  public created() {
    this.loadingStatusShow([
      this.getData(),
      this.currencyFindAll().then((response: Currency[]) => (this.currencyList = response)),
    ]).then(() => {
      this.isLoading = false;
    });
  }
}
